module.exports = __webpack_public_path__ + "static/img/IMG_20150307_172719.2f78c226.jpg";